<template>
  <div class="font-weight-bold mb-1">
    <div class="d-flex justify-space-between">
      <span>
        {{ data.title }}
      </span>
      <v-dialog v-model="visible" width="400">
        <template #activator="{ on }">
          <v-btn icon small v-on="on">
            <v-icon small>
              fal fa-info-circle
            </v-icon>
          </v-btn>
        </template>
        <v-card outlined>
          <v-card-title class="text-h5" primary-title>
            {{ data.title }}
          </v-card-title>
          <v-card-text>
            <p>
              {{ data.description }}
            </p>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text small @click="visible = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CurationGroupTitle',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      visible: false
    }
  }
}
</script>
